import { render, staticRenderFns } from "./TaskAssignments.vue?vue&type=template&id=53ad150a&scoped=true"
import script from "./TaskAssignments.vue?vue&type=script&lang=js"
export * from "./TaskAssignments.vue?vue&type=script&lang=js"
import style0 from "./TaskAssignments.vue?vue&type=style&index=0&id=53ad150a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ad150a",
  null
  
)

export default component.exports